/**
 * Syncs cart note attribute SubjSuffix from hidden line item properties (_SubjSuffix).
 * Used by staff notification email subject lines.
 */
(function () {
  var LINE_PROP = '_SubjSuffix';
  var CART_ATTR = 'SubjSuffix';
  // Extend this list when Wedding Cake, Custom Cake, etc. are added.
  var PRIORITY = ['Specialty Cake'];

  function suffixFromCart(cart) {
    if (!cart || !cart.items || !cart.items.length) return '';

    var found = [];
    cart.items.forEach(function (item) {
      if (!item.properties) return;
      var val = item.properties[LINE_PROP];
      if (val && found.indexOf(val) === -1) found.push(val);
    });

    if (!found.length) return '';

    for (var i = 0; i < PRIORITY.length; i++) {
      if (found.indexOf(PRIORITY[i]) !== -1) return PRIORITY[i];
    }

    return found[0];
  }

  function syncSubjSuffix(cart) {
    var next = suffixFromCart(cart);
    var current = (cart.attributes && cart.attributes[CART_ATTR]) || '';
    if (next === current) return Promise.resolve(cart);

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { SubjSuffix: next } }),
    }).then(function (response) {
      return response.json();
    });
  }

  function fetchAndSync() {
    return fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(syncSubjSuffix)
      .catch(function () {});
  }

  window.ssbSyncSubjSuffix = fetchAndSync;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchAndSync);
  } else {
    fetchAndSync();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, fetchAndSync);
  }
})();
